/* LIGAS wishlist — locale-aware guest wishlist stored in localStorage. */
(function () {
  'use strict';

  var KEY = 'ligas:wishlist:v1';
  var HEART_OUTLINE = '<svg class="lw-outline" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 20.5s-7.5-4.8-9.7-9.2C.8 8.2 2.6 4.5 6.2 4.5c2.2 0 3.9 1.3 4.8 3 .9-1.7 2.6-3 4.8-3 3.6 0 5.4 3.7 3.9 6.8-2.2 4.4-9.7 9.2-9.7 9.2z"/></svg>';
  var HEART_FILL = '<svg class="lw-fill" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 20.5s-7.5-4.8-9.7-9.2C.8 8.2 2.6 4.5 6.2 4.5c2.2 0 3.9 1.3 4.8 3 .9-1.7 2.6-3 4.8-3 3.6 0 5.4 3.7 3.9 6.8-2.2 4.4-9.7 9.2-9.7 9.2z"/></svg>';
  var BAG_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 8h14l-1 12H6L5 8z"/><path d="M8.5 10V6.5a3.5 3.5 0 0 1 7 0V10"/></svg>';
  var configCache;
  var lastDrawerTrigger;

  function config() {
    if (configCache) return configCache;
    var el = document.querySelector('[data-lw-config]');
    try { configCache = JSON.parse(el ? el.textContent : '{}') || {}; } catch (e) { configCache = {}; }
    return configCache;
  }
  function t(key) { return config()[key] || key; }
  function rootUrl() {
    var root = config().root_url || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }
  function localizedPath(path) {
    if (!path) return rootUrl();
    if (/^(https?:)?\/\//.test(path) || path.indexOf(rootUrl()) === 0) return path;
    return rootUrl() + path.replace(/^\//, '');
  }
  function money(cents) {
    var lang = document.documentElement.lang || 'pl';
    var currency = config().currency || 'PLN';
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }
  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(list) ? list.filter(function (item) { return item && typeof item.h === 'string'; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* Storage may be unavailable. */ }
    document.dispatchEvent(new CustomEvent('ligas:wishlist', { detail: { count: list.length } }));
  }
  function has(handle) { return read().some(function (item) { return item.h === handle; }); }
  function add(item) { if (!has(item.h)) write(read().concat([{ h: item.h, ts: Date.now() }])); }
  function remove(handle) { write(read().filter(function (item) { return item.h !== handle; })); }
  function handleFromUrl(url) {
    var match = (url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  window.LigasWishlist = { read: read, has: has, add: add, remove: remove };

  function syncHeader() {
    var active = read().length > 0;
    document.querySelectorAll('[data-ligas-wishlist-header]').forEach(function (el) {
      el.classList.toggle('is-active', active);
    });
  }
  function syncHeart(button) {
    var active = has(button.dataset.lwHandle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', active ? t('remove_item') : t('add_item'));
  }
  function syncHearts() {
    document.querySelectorAll('.ligas-heart[data-lw-handle]').forEach(syncHeart);
  }

  function drawerEls() {
    return {
      root: document.querySelector('[data-lw-drawer]'),
      img: document.querySelector('[data-lw-drawer-img]'),
      name: document.querySelector('[data-lw-drawer-name]'),
      meta: document.querySelector('[data-lw-drawer-meta]'),
      price: document.querySelector('[data-lw-drawer-price]')
    };
  }
  function openDrawer(item, trigger) {
    var drawer = drawerEls();
    if (!drawer.root) return;
    lastDrawerTrigger = trigger || document.activeElement;
    if (drawer.img) {
      if (item.img) drawer.img.src = item.img;
      else drawer.img.removeAttribute('src');
      drawer.img.alt = item.title || '';
    }
    if (drawer.name) drawer.name.textContent = item.title || '';
    if (drawer.meta) drawer.meta.textContent = item.colour ? t('colour_label') + ': ' + item.colour : '';
    if (drawer.price) drawer.price.textContent = item.price || '';
    drawer.root.removeAttribute('inert');
    drawer.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lw-open');
    requestAnimationFrame(function () {
      var close = drawer.root.querySelector('[data-lw-close]');
      if (close) close.focus();
    });
  }
  function closeDrawer() {
    var root = drawerEls().root;
    if (!root || root.getAttribute('aria-hidden') === 'true') return;
    document.body.classList.remove('lw-open');
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('inert', '');
    if (lastDrawerTrigger && document.contains(lastDrawerTrigger)) lastDrawerTrigger.focus();
    lastDrawerTrigger = null;
  }
  function trapDrawerFocus(event) {
    var root = drawerEls().root;
    if (!root || root.getAttribute('aria-hidden') === 'true' || event.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(root.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-lw-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
    trapDrawerFocus(event);
  });

  function makeHeart(handle, itemFromDom, extraClass) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ligas-heart' + (extraClass ? ' ' + extraClass : '');
    button.dataset.lwHandle = handle;
    button.innerHTML = HEART_OUTLINE + HEART_FILL;
    syncHeart(button);
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (has(handle)) remove(handle);
      else { add({ h: handle }); openDrawer(itemFromDom(), button); }
    });
    return button;
  }
  function visiblePriceText(price) {
    if (!price) return '';
    // textContent on the parent includes hidden test arms AND the JSON variant map.
    var arm = window.__ligasPT ? window.__ligasPT.arm : 'a';
    var tested = price.querySelector('[data-pt-price="' + arm + '"]') || price.querySelector('[data-pt-price="a"]');
    return (tested || price).textContent.trim();
  }
  function injectCardHearts(scope) {
    (scope || document).querySelectorAll('.product-card').forEach(function (card) {
      if (card.querySelector('.ligas-heart')) return;
      var link = card.querySelector('a[href*="/products/"]');
      var handle = link && handleFromUrl(link.getAttribute('href'));
      if (!handle) return;
      card.appendChild(makeHeart(handle, function () {
        var title = card.querySelector('[class*="title"]');
        var price = card.querySelector('[class*="price"]');
        var image = card.querySelector('img');
        return { h: handle, title: title ? title.textContent.trim() : handle, price: visiblePriceText(price), img: image ? image.currentSrc || image.src : '', colour: '' };
      }));
    });
  }
  function injectPdpHeart() {
    var handle = handleFromUrl(location.pathname);
    var title = document.querySelector('.product-info__title');
    if (!handle || !title || title.parentElement.classList.contains('lw-title-row')) return;
    var row = document.createElement('div');
    row.className = 'lw-title-row';
    title.parentNode.insertBefore(row, title);
    row.appendChild(title);
    row.appendChild(makeHeart(handle, function () {
      var image = document.querySelector('.product-gallery img, [class*="gallery"] img, main img');
      var price = document.querySelector('.product-info [class*="price"]');
      return { h: handle, title: title.textContent.trim(), price: visiblePriceText(price), img: image ? image.currentSrc || image.src : '', colour: '' };
    }, 'ligas-heart--pdp'));
  }

  function colourOf(product) {
    var option = (product.options || []).filter(function (item) {
      return ['kolor', 'colour', 'color', 'farbe', 'couleur', 'colore'].indexOf((item.name || '').toLowerCase()) !== -1;
    })[0];
    return option && option.values && option.values[0] ? option.values[0] : '';
  }
  function fetchProduct(handle) {
    return fetch(localizedPath('products/' + handle + '.js')).then(function (response) {
      if (!response.ok) throw new Error(handle);
      return response.json();
    });
  }
  function renderPage() {
    var root = document.querySelector('[data-lw-page]');
    if (!root) return;
    var rows = root.querySelector('[data-lw-rows]');
    var empty = root.querySelector('[data-lw-empty]');
    var recommendations = root.querySelector('[data-lw-reco]');
    var list = read();
    rows.innerHTML = '';
    if (!list.length) {
      empty.hidden = false;
      if (recommendations) recommendations.hidden = true;
      return;
    }
    empty.hidden = true;
    Promise.all(list.map(function (item) { return fetchProduct(item.h).catch(function () { return null; }); })).then(function (products) {
      var live = products.filter(Boolean);
      if (live.length !== list.length) write(list.filter(function (item) { return live.some(function (product) { return product.handle === item.h; }); }));
      live.forEach(function (product) {
        var row = document.createElement('div');
        var image = String(product.featured_image || (product.images && product.images[0]) || '');
        var colour = colourOf(product);
        var url = localizedPath('products/' + product.handle);
        row.className = 'lw-row';
        row.innerHTML = '<a class="lw-row__media"><img class="lw-row__img" width="104" height="139" loading="lazy"></a><div><p class="lw-row__name"><a></a></p><p class="lw-row__meta"></p><p class="lw-row__price"></p></div><div class="lw-row__side"><button type="button" class="lw-row__remove"></button><a class="lw-row__bag">' + BAG_SVG + '</a></div>';
        row.querySelectorAll('a').forEach(function (anchor) { anchor.href = url; });
        var rowImage = row.querySelector('.lw-row__img');
        if (image) rowImage.src = image + (image.indexOf('?') > -1 ? '&' : '?') + 'width=240';
        rowImage.alt = product.title;
        row.querySelector('.lw-row__name a').textContent = product.title;
        row.querySelector('.lw-row__meta').textContent = colour ? t('colour_label') + ': ' + colour : '';
        row.querySelector('.lw-row__price').textContent = money(product.price);
        var removeButton = row.querySelector('.lw-row__remove');
        removeButton.textContent = t('remove');
        removeButton.addEventListener('click', function () { remove(product.handle); });
        row.querySelector('.lw-row__bag').setAttribute('aria-label', t('choose_options'));
        rows.appendChild(row);
      });
      if (recommendations && live[0]) renderRecommendations(recommendations, live[0].id, live.map(function (product) { return product.handle; }));
    });
  }
  function renderRecommendations(root, seedId, excluded) {
    var grid = root.querySelector('[data-lw-reco-grid]');
    function paint(products) {
      var picks = products.filter(function (product) { return excluded.indexOf(product.handle) === -1; }).slice(0, 4);
      if (!picks.length) { root.hidden = true; return; }
      root.hidden = false;
      grid.innerHTML = '';
      picks.forEach(function (product) {
        var image = String(product.featured_image || (product.images && product.images[0] && (product.images[0].src || product.images[0])) || '');
        var url = localizedPath('products/' + product.handle);
        var price = product.price_min != null ? product.price_min : product.price;
        var card = document.createElement('div');
        card.className = 'lw-reco__card';
        card.innerHTML = '<a><img class="lw-reco__img" width="400" height="533" loading="lazy"></a><p class="lw-reco__name"><a></a></p><p class="lw-reco__price"></p>';
        card.querySelectorAll('a').forEach(function (anchor) { anchor.href = url; });
        var cardImage = card.querySelector('img');
        if (image) cardImage.src = image + (image.indexOf('?') > -1 ? '&' : '?') + 'width=400';
        cardImage.alt = product.title;
        card.querySelector('.lw-reco__name a').textContent = product.title;
        card.querySelector('.lw-reco__price').textContent = money(price);
        card.appendChild(makeHeart(product.handle, function () { return { h: product.handle, title: product.title, price: money(price), img: image, colour: '' }; }));
        grid.appendChild(card);
      });
    }
    fetch(localizedPath('recommendations/products.js') + '?product_id=' + encodeURIComponent(seedId) + '&limit=8&intent=related')
      .then(function (response) { return response.ok ? response.json() : Promise.reject(new Error('recommendations')); })
      .then(function (data) { if (!data.products || !data.products.length) throw new Error('empty'); paint(data.products); })
      .catch(function () {
        fetch(localizedPath('collections/collection-aw26/products.json') + '?limit=12')
          .then(function (response) { if (!response.ok) throw new Error('collection'); return response.json(); })
          .then(function (data) {
            paint((data.products || []).map(function (product) {
              return { handle: product.handle, title: product.title, featured_image: product.images && product.images[0] && product.images[0].src, price: product.variants && product.variants[0] ? Math.round(parseFloat(product.variants[0].price) * 100) : 0 };
            }));
          })
          .catch(function () { root.hidden = true; });
      });
  }

  var injectionFrame;
  function scheduleInjection() {
    if (injectionFrame) return;
    injectionFrame = requestAnimationFrame(function () { injectionFrame = null; injectCardHearts(); injectPdpHeart(); });
  }
  function init() {
    syncHeader();
    scheduleInjection();
    renderPage();
    new MutationObserver(scheduleInjection).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('ligas:wishlist', function () { syncHeader(); syncHearts(); renderPage(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
